// extracted by mini-css-extract-plugin
export var danger = "_3k-6";
export var lightPink = "_3k-a";
export var medium = "_3k-j";
export var nearSquare = "_3k-m";
export var neutralBlue = "_3k-8";
export var neutralYellow = "_3k-7";
export var noCapitalize = "_3k-1";
export var normal = "_3k-2";
export var pill = "_3k-0";
export var primary = "_3k-3";
export var primaryLight = "_3k-4";
export var shadow = "_3k-n";
export var small = "_3k-k";
export var solidBlack = "_3k-i";
export var solidGreen = "_3k-d";
export var solidLightBlue = "_3k-f";
export var solidNavy = "_3k-e";
export var solidOrange = "_3k-h";
export var solidPink = "_3k-g";
export var solidRed = "_3k-b";
export var solidWhite = "_3k-9";
export var solidYellow = "_3k-c";
export var success = "_3k-5";
export var xsmall = "_3k-l";